import BrokeragesHome from './BrokeragesHome';

export default BrokeragesHome;
